import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import App from './App'
import './styles.css'

registerSW({
  onNeedRefresh() {
    window.dispatchEvent(new CustomEvent('site-audit-update-ready'))
  },
  onOfflineReady() {
    window.dispatchEvent(new CustomEvent('site-audit-offline-ready'))
  },
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
